import { Loader, Star } from 'lucide-react'
import { useState } from 'react'
import { showAlertError } from 'src/components/alertError'
import type { NewPixFormProps } from '.'
import successNewPixTransaction from '../../../../../assets/successNewPixTransaction.svg'

interface SuccessStepProps extends NewPixFormProps {
  handleFavorite?: () => Promise<void>
}

export function SuccessOnTransactionStep({
  nextStep,
  handleFavorite,
}: SuccessStepProps) {
  const [loading, setLoading] = useState(false)

  const _handleFavorite = async () => {
    try {
      if (handleFavorite) {
        setLoading(true)
        await handleFavorite()
        setLoading(false)
      }
    } catch (err) {
      setLoading(false)
      showAlertError('Esse contato já está salvo nos favoritos')
    }
  }

  return (
    <div className="flex flex-col gap-[1.875rem] w-[570px] min-h-[517px] items-center justify-center px-12 py-20 drop-shadow-md rounded-[1.875rem]">
      <img src={successNewPixTransaction} alt="check icon" />
      <p className="text-[1.875rem] font-semibold text-center w-80">
        Pix realizado com sucesso!
      </p>
      <div className="flex flex-col gap-4">
        <button
          type="button"
          onClick={nextStep}
          className="text-[0.9375rem] py-4 font-bold bg-[#004A8A] w-[475px] text-white h-[55px] flex items-center justify-center rounded-[10px] transition hover:brightness-75"
        >
          Ver comprovante
        </button>
        <button
          type="button"
          onClick={_handleFavorite}
          className="text-[0.9375rem] gap-1 py-4 font-bold bg-[#004A8A] w-[475px] text-white h-[55px] flex items-center justify-center rounded-[10px] transition hover:brightness-75"
        >
          {loading ? (
            <>
              <Loader size={20} color="#aaa" className="animate-spin" />
            </>
          ) : (
            <>
              Salvar nos favoritos
              <Star size={16} color="white" fill="white" />
            </>
          )}
        </button>
      </div>
    </div>
  )
}
